import { IOperation, ITelemetry } from '@/models/IFunctionality';
import { IRecords } from '@/models/IRecord';
import { Chip } from '@destination/components';
import { slugify } from '@/utils/text-utils';
import { FunctionalityTelemetryDetail } from './FunctionalityTelemetryDetail';
import ModelAttributeCard from '@components/model/details/ModelAttributeCard';

export interface IFunctionalityTelemetryList {
  telemetries: ITelemetry[];
  operations: IOperation[];
  records: IRecords;
  'data-testid'?: string;
}

export function FunctionalityTelemetryList({
  telemetries,
  operations,
  records,
  'data-testid': dataTestId
}: IFunctionalityTelemetryList) {
  const titleComponent = (setting: ITelemetry) => (
    <div className="flex items-center w-full justify-between">
      <div className="tw-text-base w-1/4">{setting.name}</div>
      <div className="flex items-center w-3/4">
        <Chip label={setting.operation.$ref} />
      </div>
    </div>
  );

  return (
    <div data-testid={dataTestId}>
      {telemetries.map(telemetry => {
        return (
          <ModelAttributeCard
            variant="LIGHT"
            key={slugify(telemetry.name)}
            title={titleComponent(telemetry)}
          >
            <div className="p-3 bg-slate-50">
              <FunctionalityTelemetryDetail
                telemetry={telemetry}
                operations={operations}
                records={records}
              />
            </div>
          </ModelAttributeCard>
        );
      })}
    </div>
  );
}
